var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cnHeader"},[_c('img',{staticClass:"cnHlogo",attrs:{"src":require("@/common/assets/styles/corp/images/vzlogoLarge.png")}})]),_c('div',{staticClass:"cnRectangle"})])
}]

export { render, staticRenderFns }